// src/helpers/drawResultLookup.ts
// Đọc file kết quả quay số công khai trên MinIO (DrawPrize/{issuancePlanId}.json — payout-service
// upload, xem DrawResultStorageService.cs) và chấm vé — dùng chung giữa LookupPortal (nhân viên tra
// cứu thủ công) và TicketLookup (trang public mở từ QR ký JWT, xem ticketTokenVerifier.ts).

import appConfig from 'config';
import { CacheService } from 'services/cache';
import { CacheConfig } from 'services/cache/CacheConfig';

export interface DrawResultPrize {
  prizeTierCode: string;
  displayName: string;
  winningNumbers: string[];
  valuePerTicket: number;
}

export interface DrawResultFile {
  issuancePlanId: number;
  region: string;
  drawDate: string;
  prizes: DrawResultPrize[];
}

// Khop giai theo dung quy uoc xo so truyen thong: ve trung 1 giai neu N so cuoi cua ve trung voi so
// da cong bo cua giai do (N = do dai chinh so cua tung giai — VD Giai Bay chi can khop 2 so cuoi).
// Khong the tai tao day du cac matchingRule khac (last_n/first_n_wrong/any_n_wrong) cua
// PrizeMatchingHelper.cs ben payout-service vi file export public khong kem theo metadata
// matchingRule/matchingDigits cho tung giai — endsWith bao phu dung ca 2 truong hop dang dung
// (exact: winningNumber dai bang ca ve; last_n: winningNumber ngan hon).
export const isTicketMatchPrize = (ticketNumber: string, prize: DrawResultPrize) =>
  prize.winningNumbers.some((winningNumber) => ticketNumber.endsWith(winningNumber));

export const getDrawResultCacheKey = (issuancePlanId: string | number) =>
  `${CacheConfig.DRAW_RESULT.key}_${issuancePlanId}`;

// Cache theo tung ky (1 file/ky, khong doi sau khi da cong bo) — check localStorage truoc, chi
// fetch MinIO (goi len) khi cache miss/het TTL. Khong cache ket qua loi/404 (file chua ton tai) de
// lan check tiep theo van thu goi lai, tranh mac ket o "chua co du lieu" neu ket qua duoc nhap sau.
export const fetchDrawResultFile = async (issuancePlanId: string | number): Promise<DrawResultFile | null> => {
  const cacheKey = getDrawResultCacheKey(issuancePlanId);
  const cached = CacheService.get<DrawResultFile>(cacheKey);
  if (cached.cached && cached.data) return cached.data;

  const url = `${appConfig.minio.ENDPOINT}/${appConfig.minio.BUCKET_NAME}/DrawPrize/${issuancePlanId}.json`;
  const response = await fetch(url);
  if (!response.ok) return null;

  const data: DrawResultFile = await response.json();
  CacheService.set(cacheKey, data, CacheConfig.DRAW_RESULT.ttl);
  return data;
};
